import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=71a8bd74&scoped=true&"
import script from "./base-select.vue?vue&type=script&lang=js&"
export * from "./base-select.vue?vue&type=script&lang=js&"
import style0 from "./base-select.vue?vue&type=style&index=0&id=71a8bd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8bd74",
  null
  
)

export default component.exports